export const FILE_POST_RESET = 'file_post_reset';
export const FILE_POST = 'file_post';
